import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIModule } from '@ot/ifta/ui';
import { TimeFormatPipe, UtilsModule } from '@ot/ifta/utils';
import { DataGridModule } from '@ot/shared/data-grid';
import { SharedDirectivesModule } from '@ot/shared/directives';
import { DynamicFormModule } from '@ot/shared/dynamic-form';
import { PaginationModule } from '@ot/shared/pagination';
import { JurisdictionPipe, NotificationModule } from '@ot/shared/utils';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
  imports: [
    ClipboardModule,
    CommonModule,
    DataGridModule,
    DynamicFormModule,
    NotificationModule,
    PaginationModule,
    SharedDirectivesModule,
    UIModule,
    UtilsModule
  ],
  declarations: [],
  exports: [
    ClipboardModule,
    CommonModule,
    DataGridModule,
    DynamicFormModule,
    NotificationModule,
    PaginationModule,
    SharedDirectivesModule,
    UIModule,
    UtilsModule
  ],
  providers: [CurrencyPipe, TimeFormatPipe, DatePipe, JurisdictionPipe]
})
export class SharedModule {}
